import React from "react"
import { CardHeader, Stack, Typography } from "@mui/material"
import InfoCard from "components/controls/InfoCard"

const Financial = () => {
  return (
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <InfoCard title="FINANCIALS">
        <p>
          AHLA is committed to financial transparency. Below are our annual
          filings and tax documents available for public review.
        </p>
        <Stack spacing={1}>
          <ul>
            <li>
              <a href="/assets/docs/ahla_financials_24.pdf">Form 199 (2024)</a>
            </li>
          </ul>
        </Stack>
      </InfoCard>
    </Stack>
  )
}

export default Financial
